import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Login } from '../Pages/login';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div className="min-h-screen bg-[#f8fafc] text-[#0f172a] flex flex-col">
        <NavMenu onShowLogin={this.handleShowLogin} />
        <main className="flex-1">{this.props.children}</main>
        <footer className="bg-white border-t border-[#e2e8f0] text-[#64748b] mt-auto">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
            <div className="flex items-center gap-2 text-[#0f172a]">
              <span className="w-7 h-7 rounded-lg bg-[#0f172a] text-white flex items-center justify-center text-xs">
                ⚡
              </span>
              <span className="font-bold">Haki</span>
              <span className="text-xs font-normal"> by Nekobiz</span>
            </div>
            <div className="text-[11px]">
              Automation on demand · © {new Date().getFullYear()}
            </div>
          </div>
        </footer>
        <Login />
      </div>
    );
  }
}
